import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowBottomRightCorner"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M11.5 17.5H17.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17 17L11 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowBottomRightCorner;
